"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M38 20h-2v-2a12 12 0 1 0-24 0v2h-2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V22a2 2 0 0 0-2-2zM26 33.445V37a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3.555a4 4 0 1 1 4 0zM32 20H16v-2a8 8 0 1 1 16 0z" })
);

